import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { CarrierRoot } from '@repo/sdk'
import { KOREAN_CARRIER_VALUES } from '@repo/shared'

export interface CarrierOption {
  value: CarrierRoot
  label: string
}

export function useCarrierOptions(): CarrierOption[] {
  const { t } = useTranslation()

  return useMemo(
    () =>
      KOREAN_CARRIER_VALUES.map((carrier) => ({
        value: carrier,
        label: t(`common.carriers.${carrier}`),
      })),
    [t],
  )
}
